{
  "seo": {
    "title": "Готовые решения для amoCRM — {{count}} инструментов для автоматизации",
    "description": "{{count}} проверенных инструментов для amoCRM: генерация документов, умный подбор кандидатов, объекты недвижимости, расчёт зарплат, квиз-боты и многое другое. Подключение за 1 день.",
    "keywords": "готовые решения amoCRM, инструменты amoCRM, автоматизация amoCRM, виджеты amoCRM, интеграции amoCRM",
    "canonicalPath": "/solutions"
  },
  "hero": {
    "backLabel": "Назад на главную",
    "title": "Готовые решения для amoCRM",
    "text": "{{count}} проверенных инструментов, которые расширяют возможности вашей CRM — от автоматизации документов до умного подбора кандидатов и объектов недвижимости"
  },
  "labels": {
    "features": "Возможности",
    "howItWorks": "Как это работает",
    "days": "Подключение за 1 день. Бесплатная настройка под ваши процессы.",
    "request": "Оставить заявку"
  },
  "form": {
    "endpoint": "https://readdy.ai/api/form/d832lnnp40588l3v5vj0",
    "title": "Оставить заявку",
    "subtitleTemplate": "Заполните форму — мы расскажем подробнее о «{{title}}»",
    "namePlaceholder": "Ваше имя",
    "phonePlaceholder": "+7 (___) ___-__-__",
    "emailPlaceholder": "your@email.com",
    "messagePlaceholder": "Расскажите о задаче (необязательно)",
    "messagePlaceholderOptional": "Расскажите о задаче (необязательно)",
    "submitLabel": "Получить консультацию",
    "submittingLabel": "Отправка...",
    "successTitle": "Заявка отправлена!",
    "successTextTemplate": "Спасибо за интерес к «{{title}}». Мы свяжемся с вами в ближайшее время.",
    "againLabel": "Отправить ещё заявку",
    "errors": {
      "name": "Пожалуйста, укажите ваше имя",
      "phone": "Пожалуйста, укажите телефон",
      "email": "Пожалуйста, укажите email",
      "emailInvalid": "Пожалуйста, укажите корректный email",
      "generic": "Ошибка отправки. Попробуйте позже."
    },
    "fieldLabels": {
      "name": "Имя",
      "phone": "Телефон",
      "email": "Email",
      "message": "Сообщение",
      "submitHint": ""
    }
  },
  "bottomCta": {
    "title": "Не нашли подходящее решение?",
    "text": "Расскажите о задаче — разработаем индивидуальный инструмент под ваши бизнес-процессы",
    "cta": {
      "label": "Обсудить задачу",
      "href": "#contact"
    }
  },
  "items": [
    {
      "slug": "booking-arenda",
      "icon": "ri-calendar-check-line",
      "title": "Бронирование и аренда",
      "shortDesc": "Система онлайн-бронирования для аренды оборудования, помещений и услуг. Интеграция с amoCRM, автоматические напоминания и управление доступностью в реальном времени.",
      "desc": "Полноценная система онлайн-бронирования, интегрированная с amoCRM. Клиенты самостоятельно выбирают дату и время, а все данные мгновенно попадают в вашу CRM. Автоматические напоминания, управление доступностью в реальном времени и защита от двойного бронирования.",
      "features": [
        "Интеграция с amoCRM — данные о бронированиях попадают прямо в воронку",
        "Онлайн-календарь доступности в реальном времени",
        "Автоматические SMS и email-напоминания клиентам",
        "Защита от пересечения бронирований",
        "Оплата онлайн через интегрированные платёжные системы",
        "Гибкие правила отмены и переноса",
        "Аналитика загрузки и доходности по периодам"
      ],
      "howItWorks": [
        {
          "step": 1,
          "title": "Настройка календаря",
          "desc": "Загружаете расписание доступности объектов, устанавливаете цены и правила бронирования прямо в интерфейсе"
        },
        {
          "step": 2,
          "title": "Встраивание виджета",
          "desc": "Размещаете форму бронирования на сайте, в соцсетях или отправляете клиентам прямую ссылку"
        },
        {
          "step": 3,
          "title": "Автоматическая обработка",
          "desc": "Клиент выбирает дату → данные мгновенно создают сделку в amoCRM → менеджер получает уведомление"
        },
        {
          "step": 4,
          "title": "Напоминания и оплата",
          "desc": "За 24 часа клиент получает напоминание, может оплатить онлайн или подтвердить бронь"
        }
      ],
      "priceNote": "От 2 990 ₽/мес — подключение за 1 день"
    },
    {
      "slug": "calc-fields",
      "icon": "ri-calculator-line",
      "title": "Калькулятор полей",
      "shortDesc": "Автоматический расчёт значений в карточках сделок и контактов по заданным формулам. Экономия времени и исключение человеческих ошибок при подсчёте.",
      "desc": "Создавайте формулы любой сложности для автоматического расчёта значений в полях amoCRM. Складывайте стоимость услуг, считайте скидки, формируйте итоговые суммы — всё происходит мгновенно и без ошибок.",
      "features": [
        "Формулы любой сложности: +, −, ×, ÷, скобки, условия",
        "Работа с числовыми, денежными и процентными полями",
        "Автопересчёт при изменении любого связанного поля",
        "Поддержка полей сделок, контактов и компаний",
        "Встроенные функции: округление, минимум, максимум, дата",
        "Валидация формул перед сохранением"
      ],
      "howItWorks": [
        {
          "step": 1,
          "title": "Выбор поля",
          "desc": "Указываете поле, в которое будет записываться результат расчёта"
        },
        {
          "step": 2,
          "title": "Создание формулы",
          "desc": "Пишете формулу в визуальном конструкторе, выбирая поля из выпадающего списка"
        },
        {
          "step": 3,
          "title": "Автоматический расчёт",
          "desc": "При изменении любого поля в формуле результат мгновенно пересчитывается"
        },
        {
          "step": 4,
          "title": "Готово к работе",
          "desc": "Менеджеры видят актуальные цифры без ручного счёта — экономия до 2 часов в день"
        }
      ],
      "priceNote": "От 1 490 ₽/мес — настройка за 30 минут"
    },
    {
      "slug": "group-fields",
      "icon": "ri-group-line",
      "title": "Группировка полей",
      "shortDesc": "Организация полей в логические блоки и секции. Упрощённый интерфейс для менеджеров — важные данные всегда под рукой, ничего не теряется в списке.",
      "desc": "Собирайте поля amoCRM в логические группы и секции. Скрывайте второстепенные данные за спойлерами, раскрывайте важные блоки по умолчанию. Интерфейс становится чистым, а менеджеры заполняют карточки быстрее и точнее.",
      "features": [
        "Группировка полей в сворачиваемые секции",
        "Настройка порядка блоков и полей внутри них",
        "Условное отображение: показывать блок только при определённом статусе",
        "Поддержка в карточках сделок, контактов и компаний",
        "Визуальные разделители и подписи к группам",
        "Индивидуальные настройки для каждой воронки"
      ],
      "howItWorks": [
        {
          "step": 1,
          "title": "Создание групп",
          "desc": "В конструкторе создаёте секции с названиями: «Клиент», «Заказ», «Доставка», «Оплата»"
        },
        {
          "step": 2,
          "title": "Распределение полей",
          "desc": "Перетаскиваете поля в нужные секции, задаёте порядок отображения"
        },
        {
          "step": 3,
          "title": "Настройка видимости",
          "desc": "Указываете, какие блоки раскрыты по умолчанию, а какие свёрнуты"
        },
        {
          "step": 4,
          "title": "Применение",
          "desc": "Менеджеры видят структурированную карточку — заполняют быстрее и не пропускают поля"
        }
      ],
      "priceNote": "От 1 490 ₽/мес — интуитивная настройка"
    },
    {
      "slug": "block-no-tasks",
      "icon": "ri-lock-line",
      "title": "Блокировка при отсутствии задач",
      "shortDesc": "Запрет смены статуса сделки, если по ней нет активных задач. Заставляет менеджеров работать системно и не забывать про клиентов.",
      "desc": "Контролируйте дисциплину менеджеров на уровне CRM. Система не позволит перевести сделку в статус «Закрыто» или «Оплата», пока по ней не выполнены все запланированные задачи. Менеджеры вынуждены работать по процессу, а клиенты не остаются без внимания.",
      "features": [
        "Блокировка смены статуса при отсутствии невыполненных задач",
        "Гибкая настройка: для каких статусов и воронок включать блокировку",
        "Персонализированные сообщения при попытке сменить статус",
        "Исключения для руководителей и администраторов",
        "Логирование попыток обхода правил",
        "Статистика по менеджерам и нарушениям"
      ],
      "howItWorks": [
        {
          "step": 1,
          "title": "Настройка правил",
          "desc": "Выбираете воронку и статусы, при переходе в которые требуется наличие задач"
        },
        {
          "step": 2,
          "title": "Указание типов задач",
          "desc": "Задаёте, какие задачи считаются обязательными: звонок, встреча, отправка КП"
        },
        {
          "step": 3,
          "title": "Активация",
          "desc": "Включаете проверку — теперь система контролирует каждую смену статуса"
        },
        {
          "step": 4,
          "title": "Работа менеджеров",
          "desc": "При попытке перевести сделку без задач менеджер видит сообщение и создаёт задачу"
        }
      ],
      "priceNote": "От 1 990 ₽/мес — дисциплина без микроменеджмента"
    },
    {
      "slug": "block-delete-deals",
      "icon": "ri-shield-line",
      "title": "Блокировка удаления сделок",
      "shortDesc": "Защита от случайного или умышленного удаления важных сделок. Сохраняем права на объединение дублей, но исключаем потерю данных.",
      "desc": "Защитите историю работы с клиентами от случайных и умышленных удалений. Система блокирует кнопку удаления для сделок, достигших определённого этапа, при этом сохраняя возможность объединять дубли. Руководители видят полную картину, а данные не теряются.",
      "features": [
        "Блокировка удаления сделок по статусу или воронке",
        "Сохранение функции объединения дублей",
        "Возможность удаления только для администраторов",
        "Уведомления руководителю о попытках удаления",
        "Архивирование вместо удаления с возможностью восстановления",
        "История всех действий с сделкой"
      ],
      "howItWorks": [
        {
          "step": 1,
          "title": "Настройка защиты",
          "desc": "Выбираете статусы или воронки, сделки в которых нельзя удалять"
        },
        {
          "step": 2,
          "title": "Назначение прав",
          "desc": "Определяете, кто может архивировать сделки: только руководители или все"
        },
        {
          "step": 3,
          "title": "Архив вместо удаления",
          "desc": "При попытке удаления сделка уходит в архив и остаётся доступной для восстановления"
        },
        {
          "step": 4,
          "title": "Контроль",
          "desc": "Руководитель получает отчёт о всех попытках удаления и архивных сделках"
        }
      ],
      "priceNote": "От 1 490 ₽/мес — защита данных за 5 минут настройки"
    },
    {
      "slug": "fast-search",
      "icon": "ri-search-line",
      "title": "Быстрый поиск для списков",
      "shortDesc": "Мгновенный поиск по всем спискам amoCRM с фильтрами и подсказками. Находите клиентов, сделки и задачи за секунды вместо долгого пролистывания.",
      "desc": "Умный поисковый движок для amoCRM, который ищет по всем полям сделок, контактов и компаний одновременно. Начните печатать — и за миллисекунды увидите релевантные результаты с подсветкой совпадений. Фильтруйте по дате, статусу, ответственному и тегам.",
      "features": [
        "Поиск по всем полям одновременно: имя, телефон, email, примечания",
        "Мгновенные результаты без перезагрузки страницы",
        "Подсветка совпадений в результатах",
        "Фильтры: статус, воронка, дата, ответственный, теги",
        "Поиск по неполному номеру телефона",
        "Горячая клавиша Ctrl+K для мгновенного вызова"
      ],
      "howItWorks": [
        {
          "step": 1,
          "title": "Активация",
          "desc": "Устанавливаете виджет — поисковая строка появляется в верхней панели amoCRM"
        },
        {
          "step": 2,
          "title": "Ввод запроса",
          "desc": "Начинаете печатать имя, телефон или любые данные — результаты появляются мгновенно"
        },
        {
          "step": 3,
          "title": "Фильтрация",
          "desc": "Уточняете поиск фильтрами: по статусу, воронке, дате создания"
        },
        {
          "step": 4,
          "title": "Переход",
          "desc": "Кликаете на результат — мгновенно попадаете в нужную карточку"
        }
      ],
      "priceNote": "От 1 490 ₽/мес — экономия 30 минут в день на поиск"
    },
    {
      "slug": "fast-copy-deal",
      "icon": "ri-file-copy-line",
      "title": "Быстрая копия сделки",
      "shortDesc": "Одним кликом создавайте дубликат сделки со всеми данными, контактами и примечаниями. Идеально для повторных заказов и регулярных клиентов.",
      "desc": "Создавайте копии сделок в один клик со всеми данными: поля, контакты, компании, примечания и прикреплённые файлы. Идеально для повторных заказов, ежемесячных услуг и шаблонных сделок. Настраивайте, какие поля копировать, а какие сбрасывать.",
      "features": [
        "Копирование за один клик прямо из списка сделок",
        "Выбор данных для копирования: поля, контакты, примечания, файлы",
        "Автоматическая смена статуса на стартовый",
        "Шаблоны сделок — сохраняйте и копируйте типовые сделки",
        "Массовое копирование нескольких сделок",
        "Автоматическое проставление текущей даты"
      ],
      "howItWorks": [
        {
          "step": 1,
          "title": "Выбор сделки",
          "desc": "Нажимаете иконку «Копировать» рядом с нужной сделкой в списке"
        },
        {
          "step": 2,
          "title": "Настройка копии",
          "desc": "Выбираете, что переносить в новую сделку, а что оставить пустым"
        },
        {
          "step": 3,
          "title": "Создание",
          "desc": "Система создаёт дубликат с новым названием и текущей датой"
        },
        {
          "step": 4,
          "title": "Работа",
          "desc": "Менеджер дополняет новую сделку — все базовые данные уже на месте"
        }
      ],
      "priceNote": "От 990 ₽/мес — ускорение работы с постоянными клиентами"
    },
    {
      "slug": "doc-templates",
      "icon": "ri-file-list-3-line",
      "title": "Документы и таблицы по шаблонам",
      "shortDesc": "Автоматическое формирование документов DOC, таблиц XLS и PDF-отчётов по вашим шаблонам. Прямо из карточки сделки — договоры, КП и акты за секунды.",
      "desc": "Генерируйте документы любого формата прямо из amoCRM. Загрузите шаблон DOCX, XLSX или PDF — система подставит данные из карточки сделки и создаст готовый документ. Договоры, коммерческие предложения, акты и отчёты формируются за секунды, а не за часы.",
      "features": [
        "Поддержка DOCX, XLSX и PDF шаблонов",
        "Автоподстановка данных из полей сделок, контактов и компаний",
        "Вложенные таблицы и динамические списки товаров",
        "Пакетная генерация документов для нескольких сделок",
        "Сохранение истории сгенерированных документов",
        "Отправка документа на email клиента одним кликом"
      ],
      "howItWorks": [
        {
          "step": 1,
          "title": "Загрузка шаблона",
          "desc": "Загружаете шаблон документа с маркерами вида {{название_поля}}"
        },
        {
          "step": 2,
          "title": "Привязка полей",
          "desc": "Сопоставляете маркеры с полями amoCRM в визуальном конструкторе"
        },
        {
          "step": 3,
          "title": "Генерация",
          "desc": "В карточке сделки нажимаете «Создать документ» — файл формируется за секунды"
        },
        {
          "step": 4,
          "title": "Отправка",
          "desc": "Документ прикрепляется к сделке и отправляется клиенту по email"
        }
      ],
      "priceNote": "От 2 490 ₽/мес — замена рутины на автоматизацию"
    },
    {
      "slug": "client-timezone",
      "icon": "ri-time-line",
      "title": "Время у клиента по телефону",
      "shortDesc": "Определение часового пояса клиента по номеру телефона. Звоните и пишите в удобное для контакта время, повышая лояльность и ответы.",
      "desc": "Автоматически определяйте часовой пояс клиента по номеру телефона и показывайте местное время прямо в карточке. Звоните в подходящий момент, отправляйте сообщения, когда клиент точно прочитает, и планируйте встречи без путаницы с часовыми поясами.",
      "features": [
        "Определение часового пояса по коду телефона",
        "Отображение местного времени клиента в карточке",
        "Умные напоминания: «Лучшее время для звонка»",
        "Фильтрация контактов по часовым поясам",
        "Автоматическая корректировка времени встреч",
        "Поддержка мобильных и городских номеров РФ и СНГ"
      ],
      "howItWorks": [
        {
          "step": 1,
          "title": "Добавление номера",
          "desc": "При вводе телефона система автоматически определяет регион и часовой пояс"
        },
        {
          "step": 2,
          "title": "Отображение",
          "desc": "В карточке рядом с номером появляется текущее время клиента и разница с вашим"
        },
        {
          "step": 3,
          "title": "Фильтрация",
          "desc": "В списке контактов фильтруете по часовым поясам для массовых обзвонов"
        },
        {
          "step": 4,
          "title": "Планирование",
          "desc": "Система подсказывает оптимальное время звонка и корректирует время встреч"
        }
      ],
      "priceNote": "От 990 ₽/мес — рост ответа на звонки до 40%"
    },
    {
      "slug": "deals-from-contacts",
      "icon": "ri-contacts-line",
      "title": "Сделки из выборки контактов",
      "shortDesc": "Массовое создание сделок из отфильтрованного списка контактов. Экономия часов работы при запуске рассылок, акций и массовых обзвонов.",
      "desc": "Выберите сегмент контактов по любым критериям — и массово создайте для них сделки за один клик. Идеально для запуска акций, реактивации старых клиентов и обработки входящих лидов. Каждая сделка привязывается к контакту с правильными данными.",
      "features": [
        "Массовое создание сделок из фильтрованного списка контактов",
        "Автоматическая привязка контакта и компании к сделке",
        "Назначение ответственного, воронки и статуса для всех сделок",
        "Установка шаблонных задач для каждой новой сделки",
        "Предпросмотр списка перед созданием",
        "Логирование всех массовых операций"
      ],
      "howItWorks": [
        {
          "step": 1,
          "title": "Фильтрация",
          "desc": "Отбираете контакты по тегам, статусу, дате последней активности или полям"
        },
        {
          "step": 2,
          "title": "Настройка сделки",
          "desc": "Указываете воронку, статус, ответственного и шаблонное название для новых сделок"
        },
        {
          "step": 3,
          "title": "Предпросмотр",
          "desc": "Проверяете список контактов и количество сделок перед созданием"
        },
        {
          "step": 4,
          "title": "Создание",
          "desc": "Один клик — система создаёт сделки для всех отобранных контактов"
        }
      ],
      "priceNote": "От 1 490 ₽/мес — экономия 3 часов на массовых запусках"
    },
    {
      "slug": "block-task-move",
      "icon": "ri-forbid-line",
      "title": "Запрет переноса и удаления задач",
      "shortDesc": "Жёсткие правила для задач: нельзя просто перенести или стереть. Менеджеры выполняют работу в срок или объясняют причину — дисциплина без занудства.",
      "desc": "Устраните «бесконечные переносы» задач в вашей команде. Система запрещает переносить или удалять задачи без указания причины, либо ограничивает количество переносов. Менеджеры привыкают выполнять работу в срок, а руководитель видит объективную картину загрузки.",
      "features": [
        "Запрет переноса задач без указания причины",
        "Ограничение количества переносов на задачу",
        "Обязательный комментарий при переносе",
        "Запрет удаления выполненных задач",
        "Исключения для руководителей при форс-мажорах",
        "Отчёт по переносам и причинам за период"
      ],
      "howItWorks": [
        {
          "step": 1,
          "title": "Настройка правил",
          "desc": "Указываете, сколько раз можно перенести задачу и нужен ли комментарий"
        },
        {
          "step": 2,
          "title": "Применение",
          "desc": "Система следит за каждой задачей и блокирует действия по установленным правилам"
        },
        {
          "step": 3,
          "title": "Уведомления",
          "desc": "Руководитель получает отчёт о переносах с указанием причин и ответственных"
        },
        {
          "step": 4,
          "title": "Результат",
          "desc": "Менеджеры выполняют задачи в срок — просрочки снижаются до 80%"
        }
      ],
      "priceNote": "От 1 490 ₽/мес — дисциплина, которую не обижают"
    },
    {
      "slug": "hr-params",
      "icon": "ri-user-search-line",
      "title": "Подбор по параметрам — для HR",
      "shortDesc": "Фильтрация кандидатов по навыкам, опыту, зарплатным ожиданиям и локации. Автоматическое ранжирование резюме — находите идеальных сотрудников быстрее.",
      "desc": "Умная система подбора кандидатов внутри amoCRM. Загружайте резюме, указывайте требования к вакансии — и система автоматически ранжирует кандидатов по соответствию. Экономьте время HR-специалиста и находите лучших сотрудников быстрее конкурентов.",
      "features": [
        "Парсинг резюме с автоизвлечением навыков, опыта и зарплатных ожиданий",
        "Ранжирование кандидатов по проценту соответствия вакансии",
        "Фильтры: опыт, навыки, зарплата, локация, формат работы",
        "История взаимодействий с кандидатом: собеседования, тесты, офферы",
        "Воронка подбора: от резюме до выхода на работу",
        "Интеграция с job-сайтами для автопостинга вакансий"
      ],
      "howItWorks": [
        {
          "step": 1,
          "title": "Создание вакансии",
          "desc": "Указываете требования: навыки, опыт, зарплата, формат работы"
        },
        {
          "step": 2,
          "title": "Загрузка резюме",
          "desc": "Загружаете резюме в систему — данные извлекаются автоматически"
        },
        {
          "step": 3,
          "title": "Ранжирование",
          "desc": "Система сопоставляет кандидатов с вакансией и выставляет рейтинг соответствия"
        },
        {
          "step": 4,
          "title": "Подбор",
          "desc": "HR работает с топовыми кандидатами — время на просмотр резюме сокращается в 5 раз"
        }
      ],
      "priceNote": "От 2 990 ₽/мес — HR-tech для компаний любого размера"
    },
    {
      "slug": "realty-params",
      "icon": "ri-home-smile-line",
      "title": "Подбор по параметрам — для недвижимости",
      "shortDesc": "Умный подбор объектов по цене, площади, району и другим критериям. Клиенты видят только релевантные варианты — сделки закрываются быстрее.",
      "desc": "Интеллектуальная система подбора объектов недвижимости для риелторов и агентств. Клиент описывает желаемые параметры — система мгновенно находит подходящие варианты из базы и ранжирует по релевантности. Меньше ручного просмотра, больше закрытых сделок.",
      "features": [
        "Поиск объектов по 20+ параметрам: цена, площадь, этаж, район, метро",
        "Автоматическое ранжирование по степени соответствия запросу",
        "Сравнительная таблица объектов с визуальными индикаторами",
        "История просмотров и избранное клиента",
        "Автоматическая рассылка новых объектов, попавших под критерии",
        "Интеграция с ЦИАН, Авито и ДомКлик для импорта объектов"
      ],
      "howItWorks": [
        {
          "step": 1,
          "title": "Запрос клиента",
          "desc": "Клиент или менеджер вводит параметры: бюджет, район, количество комнат, этаж"
        },
        {
          "step": 2,
          "title": "Подбор",
          "desc": "Система сканирует базу и выдаёт ранжированный список подходящих объектов"
        },
        {
          "step": 3,
          "title": "Сравнение",
          "desc": "Клиент сравнивает варианты в удобной таблице с фото, ценами и характеристиками"
        },
        {
          "step": 4,
          "title": "Сделка",
          "desc": "Выбранный объект переходит в воронку — от показа до подписания договора"
        }
      ],
      "priceNote": "От 2 490 ₽/мес — риелторский инструмент нового поколения"
    },
    {
      "slug": "contractor-params",
      "icon": "ri-briefcase-line",
      "title": "Подбор по параметрам — исполнители",
      "shortDesc": "Автоматический подбор подрядчиков и исполнителей по специализации, рейтингу, стоимости и срокам. Оптимизация процесса назначения задач внутри команды.",
      "desc": "Система управления исполнителями и подрядчиками внутри amoCRM. Создавайте задачи с требованиями — система автоматически предложит наиболее подходящих исполнителей из вашей базы по специализации, рейтингу, загрузке и стоимости. Работа распределяется эффективно.",
      "features": [
        "База исполнителей с рейтингом, специализацией и портфолио",
        "Автоподбор исполнителя под задачу по критериям",
        "Учёт загрузки и доступности исполнителя",
        "Система рейтингов и отзывов после выполнения",
        "История сделок и задач по каждому подрядчику",
        "Финансовый учёт: стоимость работ, оплаты, задолженности"
      ],
      "howItWorks": [
        {
          "step": 1,
          "title": "Создание задачи",
          "desc": "Описываете задачу, указываете требуемую специализацию, бюджет и срок"
        },
        {
          "step": 2,
          "title": "Подбор",
          "desc": "Система анализирует базу исполнителей и предлагает 3 лучших кандидатов"
        },
        {
          "step": 3,
          "title": "Назначение",
          "desc": "Выбираете исполнителя — задача уходит ему с полным описанием и дедлайном"
        },
        {
          "step": 4,
          "title": "Контроль",
          "desc": "Отслеживаете выполнение, ставите оценку — рейтинг исполнителя обновляется"
        }
      ],
      "priceNote": "От 1 990 ₽/мес — marketplace исполнителей в вашей CRM"
    }
  ]
}
